/**
 * Un compte, plusieurs casquettes (migration 0045) — les refus de la base et des edge functions, en français.
 *
 * Une même personne peut être livreur (fiche `drivers`), membre de l'équipe (owner / dispatcher / accountant) et
 * client de l'offre opérée. La base refuse ce qui mélangerait les casquettes ; ses déclencheurs répondent par un
 * CODE (dans `message` côté PostgREST, dans `error` côté edge function), traduit ici.
 */
export const ERREURS_CASQUETTES: Record<string, string> = {
  casquette_non_autorisee:
    "Message refusé : dans votre propre fil de livreur, vous ne pouvez pas répondre au nom de l'équipe (et seule l'équipe active de l'organisation écrit au nom du dispatch).",
  fil_autre_organisation: "Ce fil appartient à une autre organisation. Rechargez la page.",
  message_non_modifiable: "Un message envoyé ne peut plus être modifié.",
  livreur_client_de_la_course: "Ce livreur est le client de cette course : il ne peut pas la livrer. Choisissez un autre livreur.",
  livreur_autre_organisation: "Ce livreur n'appartient pas à l'organisation de la course.",
  dernier_proprietaire:
    "Cette personne est le dernier propriétaire actif de l'organisation : nommez d'abord un autre propriétaire.",
  deja_membre:
    "Cette personne est déjà membre active de l'organisation : modifiez son rôle dans l'équipe plutôt que de l'inviter.",
}

/** La phrase d'un refus « casquettes » contenu dans une erreur (PostgREST ou edge function), sinon `null`. */
export function phraseCasquette(e: unknown): string | null {
  const o = (e && typeof e === 'object' ? e : {}) as { message?: unknown; code?: unknown; error?: unknown }
  const textes = [o.message, o.error, typeof e === 'string' ? e : undefined].filter((t): t is string => typeof t === 'string')
  for (const t of textes) {
    for (const [code, phrase] of Object.entries(ERREURS_CASQUETTES)) {
      if (t.includes(code)) return phrase
    }
  }
  return null
}

/** Relance une erreur de la base en phrase lisible si c'est un refus « casquettes », telle quelle sinon. */
export function erreurCasquette(e: unknown): unknown {
  const phrase = phraseCasquette(e)
  return phrase ? new Error(phrase) : e
}
